import IconButton from "components/iconButton/iconButton";
import {
  EmailIcon,
  LinkedInLogo,
  XLogo,
  SignalIcon,
} from "components/icons/icons";
import Toast from "components/toast/toast";

export const EmailButton = ({
  href,
  onClick,
  height = 22,
  width = 22,
}: {
  href?: string;
  onClick?: () => void;
  height?: number;
  width?: number;
}) => {
  if (!href) return null;
  return (
    <IconButton
      component="link"
      href={href}
      onClick={onClick}
      className="flex items-center justify-center"
      data-testid="emailButton"
    >
      <EmailIcon height={height} width={width} />
    </IconButton>
  );
};

export const SignalButton = ({
  signalNumber,
  onClick,
  height = 20,
  width = 20,
}: {
  signalNumber?: string;
  onClick?: () => void;
  height?: number;
  width?: number;
}) => {
  return (
    <Toast message="Signal number copied to clipboard" hide={!signalNumber}>
      <IconButton
        onClick={onClick}
        className="flex items-center justify-center"
        title="Signal"
        data-testid="signalButton"
      >
        <SignalIcon height={height} width={width} />
      </IconButton>
    </Toast>
  );
};

export const TwitterButton = ({
  href,
  onClick,
  height = 18,
  width = 18,
}: {
  href?: string;
  onClick: () => void;
  height?: number;
  width?: number;
}) => {
  if (!href) return null;
  return (
    <IconButton
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={onClick}
      component="link"
      className="flex items-center justify-center"
      title="Twitter"
      data-testid="twitterButton"
    >
      <XLogo height={height} width={width} />
    </IconButton>
  );
};

export const LinkedInButton = ({
  href,
  onClick,
  height = 20,
  width = 20,
}: {
  href?: string;
  onClick: () => void;
  height?: number;
  width?: number;
}) => {
  if (!href) return null;
  return (
    <IconButton
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={onClick}
      component="link"
      className="flex items-center justify-center"
      title="LinkedIn"
      data-testid="linkedInButton"
    >
      <LinkedInLogo height={height} width={width} />
    </IconButton>
  );
};
